export default "__VITE_ASSET__8c929354__"